import styled from "styled-components";

const Container = styled.div`
  width: 100%;
  padding-top: 4px;
  margin-bottom: -2px;

  .MuiAutocomplete-root {
    width: 100%;
  }
`;

export { Container };
